

export const difficultyLevel = [
    {
        label: 'Easy (Entry Level)',
        value: 'easy'
    },
    {
        label: 'Medium (Limited Experience)',
        value: 'medium'
    },
    {
        label: 'Hard (Working Professional)',
        value: 'hard'
    },
    {
        label: 'Expert Level (Subject Matter Expert)',
        value: 'expert'
    },
]